enum AccessReportsWizardElementTypeEnum {
  Checkbox = "Checkbox",
  ColorPicker = "ColorPicker",
  DatePicker = "DatePicker",
  Dropdown = "Dropdown",
  Input = "Input",
  Radio = "Radio",
  Table = "Table",
  Unknown = "Unknown",
}

export { AccessReportsWizardElementTypeEnum };
